import { getRegimeMappings } from "../../services/regimeMappingService";
import { selectRegimeMappings } from "../selectors/defectSelectors";
import { setRegimeMappings } from "../slices/defectSlice";
import { AppThunk } from "../store";

/**
 * Loads the regime (PSC) mappings into the defect slice.
 *
 * The mappings are reference data — the same file for every inspection, and a
 * large one — so an already-loaded copy is reused rather than refetched each
 * time the defects table mounts.
 *
 * Deliberately does not touch the slice's `loading`/`error` flags: those gate
 * the defects table itself, and the mappings only feed one information-only
 * column. A failure leaves the mappings empty and the column blank — the
 * service has already logged why.
 */
export const fetchRegimeMappings =
    (): AppThunk => async (dispatch, getState) => {
        if (Object.keys(selectRegimeMappings(getState())).length) {
            return;
        }

        const mappings = await getRegimeMappings();

        if (mappings) {
            dispatch(setRegimeMappings(mappings));
        }
    };
